import { type ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { LocationReducer } from "./LocationReducer";

const LocationContext = createContext({
  state: LocationReducer.getInitialState(),
  actions: LocationReducer.actions,
});

export const useLocationContext = () => useContext(LocationContext);

export const LocationProvider = ({ children }: { children: ReactNode }) => {
  const [state, actions] = useComplexState({
    initialState: LocationReducer.getInitialState(),
    reducers: LocationReducer.caseReducers,
  });
  return (
    <LocationContext.Provider value={{ state, actions }}>
      {children}
    </LocationContext.Provider>
  );
};
